import posthog from 'posthog-js';



export const sendTack = (event: string, properties?: Record<string, any>) => {
    posthog.capture(event, properties);
};

export const IdentifyUser = (user_id: string, properties: Record<string, any>) => {
    posthog.identify(user_id, properties);
};